<template>
    <div>
        <div class="sideBar">
            <div style="font-size: 14px;padding-left: 20px;height: 40px;line-height: 40px;color: #fff">
                <b>
                    <i class="fa fa-reorder menuIcon"></i>
                    <router-link to="/mall/booking">{{$t('mall.bookingcenter')}}</router-link>
                </b>
            </div>
            <el-col>
                <el-menu default-active="2" :router="true" class="el-menu-vertical-demo" @open="handleOpen"
                    @close="handleClose" :default-openeds="DefaultOpeneds(roots)">
                    <el-submenu v-for="(rt,i) in roots" :index="'i'+i" :key="rt.ActionID">
                        <template slot="title">
                            <b>
                                <icon style="color:#fff" :name="rt.IconName|IconName"></icon>
                                {{$t('webdata.'+rt.ActionNick)}}

                            </b>
                        </template>
                        <component :is="ch|ComponentName" v-for="ch in rt.children" :key="ch.ActionID"
                            :route="{path:ch.ActionURL}" :index="ch.ActionID" v-if="ch.showbool">
                            <div style="color:#fff" v-if="ch.children && !ch.ActionURL" slot="title">
                                <icon :name="ch.IconName|IconName"></icon>{{$t('webdata.'+ch.ActionNick)}}
                            </div>
                            <div style="color:#fff" v-else>
                                <icon style="color:#fff" :name="ch.IconName|IconName"></icon>
                                {{$t('webdata.'+ch.ActionNick)}}
                                <span v-if="ch.ActionNick=='tradereceive'" :class="{'badge':exportList.length>0}">
                                {{(exportList.length>0?exportList.length:null)}}</span>
                            </div>
                            <el-menu-item style="color:#fff" v-if="ch.children&&!ch.ActionURL" v-for="th in ch.children"
                                :key="th.ActionID" :index="th.ActionID" :route="{path:th.ActionURL}">
                                <icon :name="th.IconName|IconName"></icon>{{$t('webdata.'+th.ActionNick)}}
                                <span v-if="filterWorkTaskLists(th.ActionURL)>0"
                                    :class="{'badge':filterWorkTaskLists(th.ActionURL)>0}">{{filterWorkTaskLists(th.ActionURL)}}</span>
                                <span v-if="th.ActionNick=='orderchange'"
                                    :class="{'badge':changes.length>0}">{{(changes.length>0?changes.length:null)}}</span>
                                <span v-if="th.ActionNick=='smsnotify'"
                                    :class="{'badge':sms.length>0}">{{(sms.length>0?sms.length:null)}}</span>

                            </el-menu-item>
                        </component>
                        <!-- <el-menu-item v-if="rt.ActionName=='系统管理'" route="/System/roleowner">
                            <div style="color:#fff">
                                <icon style="color:#fff" class="fa  menuIcon"></icon>供应添加
                            </div>
                        </el-menu-item> -->
                        <!-- <el-menu-item v-if="rt.ActionName=='系统管理'" route="/api/flight/orderservice/ChangeCheckPNR">
                            <div style="color:#fff">
                                <icon style="color:#fff" class="fa  menuIcon"></icon>编码检验
                            </div>
                        </el-menu-item>
                        <el-menu-item v-if="rt.ActionName=='系统管理'" route="/system/interfaceManage">
                            <div style="color:#fff">
                                <icon style="color:#fff" class="fa  menuIcon"></icon>配置管理
                            </div>
                        </el-menu-item> -->
                    </el-submenu>
                </el-menu>
            </el-col>
        </div>
        <!-- <div class="sideBar" v-else :class="{'BookingSideBar':$route.path=='/mall/booking'}">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide ">
                            <div style="font-size: 14px;padding-left: 20px;height: 40px;line-height: 40px;color: #2d2d2d;background-color:#fff">
                                    <b>
                                        <i class="fa fa-reorder menuIcon"></i>
                                        <router-link to="/mall/booking">{{$t('mall.bookingcenter')}}</router-link>
                                    </b>
                                </div>
                                <el-col>
                                    <el-menu default-active="2" :router="true" class="el-menu-vertical-demo" @open="handleOpen"
                                        @close="handleClose" :default-openeds="DefaultOpeneds(roots)">
                                        <el-submenu v-for="(rt,i) in roots" :index="'i'+i" :key="rt.ActionID">
                                            <template slot="title">
                                                <b>
                                                    <icon :name="rt.IconName|IconName"></icon>{{$t('webdata.'+rt.ActionNick)}}
                                                </b>
                                            </template>

                                            <component :is="ch|ComponentName" v-for="ch in rt.children" :key="ch.ActionID"
                                                :index="ch.ActionID" :route="{path:ch.ActionURL}">
                                                <div v-if="ch.children && !ch.ActionURL" slot="title">
                                                    <icon :name="ch.IconName|IconName"></icon>{{$t('webdata.'+ch.ActionNick)}}
                                                </div>
                                                <div v-else>
                                                    <icon :name="ch.IconName|IconName"></icon>{{$t('webdata.'+ch.ActionNick)}}
                                                </div>
                                                <el-menu-item v-if="ch.children&&!ch.ActionURL" v-for="th in ch.children" :key="th.ActionID"
                                                    :index="th.ActionID" :route="{path:th.ActionURL}">
                                                    <icon :name="th.IconName|IconName"></icon>{{$t('webdata.'+th.ActionNick)}}
                                                </el-menu-item>
                                            </component>
                                        </el-submenu>
                                    </el-menu>
                                </el-col>

                    </div>
                </div>
                <div class="swiper-scrollbar"></div>
            </div>


        </div> -->
    </div>
</template>
<style scoped>
    .sideBar.BookingSideBar {
        position: fixed;
        top: 100px;
        /* min-height:  600px; */
        height: 500px;

        float: none;
        margin-left: 0;
    }

    .swiper-container {
        width: 100%;
        height: 100%;
    }

    .swiper-slide {
        font-size: 18px;
        height: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .nav-serach {
        line-height: 40px;
    }

    li.el-submenu {
        margin-top: 1px;
    }



    .el-menu li.el-menu-item {
        line-height: 30px;
        height: 30px;
        padding-left: 20px !important;
    }

    .menuIcon {
        margin-right: 5px;
        /* margin-left: -6px; */
        font-size: 16px;
        text-align: center;
        width: 16px;
    }

    .badge {
        background-color: #ff4949;
        border-radius: 10px;
        color: #fff;
        display: inline-block;
        font-size: 12px;
        line-height: 18px;
        padding: 0 6px;
        text-align: center;
        white-space: nowrap;
    }

</style>
<style>
    .sideBar li.el-submenu div.el-submenu__title {
        height: 40px;
        line-height: 40px;
        color: #fff;
    }

    .sideBar .el-menu div.el-menu-item-group__title {
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 20px !important;
    }

    .el-menu {
        background-color: inherit !important
    }

</style>
<script type="text/javascript">
    import {
        mapGetters
    } from 'vuex'
    import service from '../manage/order/service.js'
    export default {
        name: 'sidebar',
        props: ['name'],
        filters: {
            ComponentName(value) {
                return value.children && !value.ActionURL ? 'el-menu-item-group' : 'el-menu-item';
            },
            IconName(value) {
                return value + ' menuIcon';
            }
        },
        data() {
            return {
                changes:[],
                sms:[],
                exportList:[],
            };
        },
        computed: {
            ...mapGetters(['roots', 'actions']),
            CompanyID() {

                return this.$store.getters.ticketInfo.CompanyID;
            },
            UserID() {
                return this.$store.getters.ticketInfo.UserID;
            },
            isSupply() {
                return this.$store.getters.isSupply;
            },
            WorkTaskLists() {
                if (this.$store.getters.WorkTask) {
                    return this.$store.getters.WorkTask;
                }
            },
            ServiceCode() {
                return this.$route.params.service
            },
            ApplyArea() {
                return this.$route.query.ApplyArea
            },
            ServiceTypes() {
                return this.$store.getters.categorys.ServiceType
            },
            ApplyAreas() {
                return this.$store.getters.categorys.ApplyArea
            },
            BusinessTypeTypes() {
                return this.$store.getters.categorys.types.BusinessType
            }
        },
        watch: {
            'actions'() {
                var __self = this;
                _.forEach(__self.actions, function (ent) {
                    ent.ActionURL = ent.ActionCode.replace(/:CompanyID/g, __self.CompanyID)
                        .replace(/:UserID/g, __self.UserID);
                });
            },
        },
        mounted() {
            // var mySwiper = new Swiper('.swiper-container', {
            //     scrollbar: '.swiper-scrollbar',
            //     scrollbarHide: false,
            //     scrollbarDraggable: true,
            //     direction: 'vertical',
            //     // slidesPerView: 'auto',
            //     mousewheelControl: true,
            //     // swipeHandler: '.swipe-handler',
            //     height: 500
            // });
            let __self = this;
            __self.$store.dispatch('loadconferService').then(function () {
                __self.$store.dispatch('loadWorkTask')
                // __self.flightchanges();
                // __self.smslist();
                __self.loadExportList();
                setInterval(function () {
                    __self.$store.dispatch('loadWorkTask')
                    __self.$store.dispatch('loadAdviseList')
                    // __self.flightchanges();
                    // __self.smslist();
                    __self.loadExportList();
                }, 300000)
            });
        },
        methods: {
            loadExportList(){
                    let __self = this;
                    __self.$api.bill.getExportList().then(function (json) {
                    if (json.data.isSucc&&json.data.result) {
                        __self.exportList = json.data.result.filter((o) => o.Downloaded == false);
                    }
                    });
            },
            smslist(){
                let __self=this;
                __self.$api.adapter.smsList({PageSize:9999,SmsStatus:1151}).then(p=>{
                    if(p.data.isSucc){
                        __self.sms=p.data.result.entities
                    }
                })
            },
            flightchanges(){
                let __self=this;
                __self.$api.flight.getflightchanges({ChangeStatues:[10301,10303],PageSize:9999}).then(p=>{
                    if(p.data.isSucc){
                        __self.changes=p.data.result.entities;
                    }
                })
            },
            filterWorkTaskLists(url) {
                let __self = this;
                let WorkTaskLists = [];
                if (__self.WorkTaskLists) {
                    if (url.indexOf('order') > -1) {
                        WorkTaskLists = _.filter(__self.WorkTaskLists, o => {
                            return o.BusinessType == __self.BusinessTypeTypes.Sales || o.BusinessType == __self
                                .BusinessTypeTypes.Change;
                        })
                    }
                    if (url.indexOf('amend') > -1) {
                        WorkTaskLists = _.filter(__self.WorkTaskLists, o => {
                            return o.BusinessType == __self.BusinessTypeTypes.Amend;
                        })
                    }
                    let ServiceType = _.find(__self.ServiceTypes, o => {
                        let CategoryCode = _.toLower(o.CategoryCode.replace('Service', ''))
                        return url.indexOf(CategoryCode) > -1;
                    })
                    let ApplyArea = _.find(__self.ApplyAreas, o => {
                        let CategoryID = o.CategoryID
                        return url.indexOf(CategoryID) > -1;
                    })
                    if (ServiceType && ApplyArea) {
                        let result = _.find(service.ServiceDate, o => {
                            return o.ServiceCode == _.toLower(ServiceType.CategoryCode.replace('Service',
                                '')) && o.ApplyArea == ApplyArea.CategoryID
                        })
                        if (result) {
                            let data = _.filter(WorkTaskLists, o => {
                                return o.FlowCode == _.upperFirst(ServiceType.CategoryCode.replace('Service',
                                        '')) && o.ServiceID == result
                                    .ServiceID
                            })
                            return data.length
                        }
                    }

                }
            },
            ChaneUrl(url) {
                let __self = this;
                __self.$router.replace({
                    path: url,
                })
            },
            handleOpen(key, keyPath) {
                // console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                // console.log(key, keyPath);
            },
            DefaultOpeneds(roots) {
                var __self = this;
                let Opened = false;
                var root = _.find(roots, o => o.ActionName == "服务管理");
                if (root) {
                    Opened = true;
                }
                let DefaultOpeneds = [];
                for (let i = 0; i < roots.length; i++) {
                    if (Opened && roots[i].ActionName == "订单管理") {
                        continue;
                    }
                    DefaultOpeneds.push("i" + i);
                }
                //先行去掉应收账期和应收明细
                if (roots && roots.length > 0) {
                    __self.billromove(__self.roots);
                }

                return DefaultOpeneds;
            },
            billromove(data) {
                let __self = this;
                for (let c = 0; c < data.length; c++) {
                    data[c].showbool = true;
                    // if ((data[c].ActionName == '应收账期' || data[c].ActionName == "应收明细") && !__self.isSupply) {
                    //     data[c].showbool = false;
                    // }
                    if (data[c].children && data[c].children.length > 0) {
                        __self.billromove(data[c].children);
                    }
                }
            }

        }

    }

</script>



// WEBPACK FOOTER //
// sidebar.vue?9cf64332